import 'rxjs/add/operator/map';

import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MdPaginator, MdSort } from '@angular/material';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { userRole_proctorLead } from './../../Common/appConstant';
import { TableDataSource } from './../../Common/md-table';
import { AppGlobals } from './../../Common/Services/app.global';
import { SharedService } from './../../Common/Services/shared.service';
import { Utility } from './../../Common/Services/utility';
import { AdmManageProctorTeamLeadService } from './adm-manage-proctor-team-lead.service';
import { AppUrl } from './../../Common/appUrl';
import { IesHttpClient } from '../../Common/ies-http-client.service';

@Component({
  selector: 'app-adm-manage-proctor-team-lead',
  templateUrl: './adm-manage-proctor-team-lead.component.html',
  styleUrls: ['./adm-manage-proctor-team-lead.component.css'],

})
export class AdmManageProctorTeamLeadComponent implements OnInit {
  @ViewChild(MdPaginator) paginator: MdPaginator;
  @ViewChild(MdSort) sort: MdSort;

  // used in html to pass url/searchParams to update pagination
  appUrl = AppUrl;
  remotePaginationParams;
  httpClient: IesHttpClient; // used to make object of md-table
  dataSource: TableDataSource | null;
  form: FormGroup;
  isSearchDisable: boolean;
  nameFilteredOptions: any;
  officeFilteredOptions: any;
  groupOptions: any;
  role: any;
  showField: boolean = true;
  proctorLeadOptions: any = [{ text: 'Yes', value: 1 }, { text: 'No', value: 0 }];
  dataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]); // store all grid data
  paginationInfo: any = { totalRecords: 0 }; // Set initial value of Totalrecords property
  displayedColumns = ['firstName', 'userEmail', 'officeName', 'contactNumber', 'groupName', 'isDeleted', 'Action']; // isDeleted column in status
  constructor(
    private _sharedService: SharedService, public _utility: Utility, public _appGlobal: AppGlobals,
    private _service: AdmManageProctorTeamLeadService, private _router: Router, httpClient: IesHttpClient
  ) {
    this.httpClient = httpClient;
    this.form = new FormGroup({
      name: new FormControl(),
      office: new FormControl(),
      group: new FormControl(),
      proctorLead: new FormControl()
    });

  }

  ngOnInit() {
    this.loadGroups();
    this.loadOffices();
    this.getList("1?pageSize=100");
    this.dataSource = new TableDataSource(this.dataSubject, this.paginator, this.sort, this.httpClient);

    this.form.valueChanges
      .debounceTime(300)
      .distinctUntilChanged()
      .subscribe(form => {
        this.isSearchDisable = this.searchDisable(form, ['name', 'proctorLead']);
      });

    this.form.controls.name.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe(value => {
        if (value.length > 2) { // search Name if minimum three characters typed.
          this.loadNames(value);
        }
      });
    this._service.proctorLeadList = this.proctorLeadOptions;
    this.checkPermission();
  }

  checkPermission() {
    this.role = this._utility.getUserRole();
    if (this.role && this.role == userRole_proctorLead) {
      this.showField = false;
    } else {
      this.showField = true;
    }
  }

  //handle search button
  searchDisable(form: any, otherFields: any = []): boolean {
    let isSearchDisable = true;
    let keys = Object.keys(form);
    let values = this._utility.objValues(form);
    for (var i = 0; i < values.length; i++) {
      let value = values[i];
      if (value && value.length != 0) {
        if ((value.id || otherFields.indexOf(keys[i]) > -1) || value[0].id) {
          isSearchDisable = false;
        } else {
          isSearchDisable = true;
          break;
        }
      }
      else {
        isSearchDisable = false;
      }
    }
    return isSearchDisable;
  }

  /**
   * Load Name records after entered some value in Name search field
   * @param value - typed value in Name field
   */
  loadNames(value) {
    this.nameFilteredOptions = [];
    this._service.getProctorNames(value).subscribe((response: any) => {
      this._utility.onSuccessCallback(response, null, () => {
        if (response.response.results.length != 0) {
          let distinctRecord = this._utility.checkDuplicateRecord(response.response.results);
          this.nameFilteredOptions = distinctRecord;
        }

      });
    }, error => this._utility.onErrorCallback(error));
  }

  loadOffices() {
    this._service.getOffice().subscribe((response: any) => {
      this._utility.onSuccessCallback(response, null, () => {
        this._sharedService.officeList = response.response.results; // set data in service so that we can use it in Update file.
        this._utility.setDataInComboField('office', null, this.form.controls.office, this);
      });
    }, error => this._utility.onErrorCallback(error));
  }

  loadGroups() {
    this._service.getGroups().subscribe((response: any) => {
      this._utility.onSuccessCallback(response, null, () => {
        this.groupOptions = response.response.results;
        this._utility.setDataInComboField('group', response.response.results, this.form.controls.group, this);
        this._service.groupList = this.groupOptions; // set data in service so that we can use it in Update file.
      });
    }, error => this._utility.onErrorCallback(error));
  }

  getList(params: any): void {
    this._utility.addLoaderCount();
    this._service.getData(params).subscribe((response: any) => {
      this._utility.onSuccessCallback(response, null, () => {
        //initialize index of grid pagination after every search
        this.paginator.pageIndex = 0;
        this.dataSource.curPage = 2;
        this.dataSubject.next(response.response.results);
        this.paginationInfo = response.response.paginationInfo;
        this._service.proctorList = response.response.results;
      });
    }, error => this._utility.onErrorCallback(error));
  }

  onSearch(): void {
    let params = "";
    let pageSizeParam = "?pageSize=100&";
    let formValues = this.form.getRawValue();

    if (formValues.name) {
      params += `proctorName=${formValues.name}&`;
    }
    if (formValues.office && formValues.office.id) {
      params += `officeId=${formValues.office.id}&`;
    }
    if (formValues.group) {
      for (let i = 0; i < formValues.group.length; i++) {
        params += `groupId=${formValues.group[i].id}&`;
      }
    }
    if (formValues.proctorLead && formValues.proctorLead.text) {
      params += `isLead=${formValues.proctorLead.value}&`;
    }
    this.remotePaginationParams = pageSizeParam + params.substring(0, params.length - 1);
    params = "1" + this.remotePaginationParams;
    this.getList(params);
  }

  onManageClick(id) {
    this._appGlobal.routeWithID = true;
    if (this.role && this.role == userRole_proctorLead) {
      this._router.navigate(['/AdmManageProctors', id]);
    } else {
      this._router.navigate(['/AdmManageProctorTeamLead', id]);
    }
  }

  // Set admin status icons based on its value
  getStatusCls(value) {
    try {
      if (value == 0) return 'activeStatusCls';
      if (value == 1) return 'retireStatusCls';
    }
    catch (Exception) { }
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-proctor-team-lead/adm-manage-proctor-team-lead.component.ts